export default {
  development: {
    ApiBaseUrl           : process.env.DELECTORY_URL ? process.env.DELECTORY_URL + '/api' : 'http://localhost:3000/api',
    BanquetUrl           : process.env.BANQUET_URL || 'http://localhost:4000',
    MerchantBanquetUrl   : process.env.DELECTORY_URL || 'http://localhost:3000',
    CDN                  : process.env.BANQUET_CDN_URL || 'http://localhost:3001',
    StripePublishableKey : 'pk_test_1qlLoY7WhrYr8MI6c5DT9u6e',
    GoogleMapsApiKey     : 'AIzaSyBVBSWmf3dz5-WoOiwB0IzuZ9x1_UXgXkg',
    SegmentWriteKey      : 'Tc2QqemIZNnPy34DMYXbWSIrSx7s6bsX'
  },
  staging: {
    ApiBaseUrl           : 'https://delectory.staging.delectable.com/api',
    MerchantBanquetUrl   : 'https://delectory.staging.delectable.com',
    BanquetUrl           : 'https://banquet.staging.delectable.com',
    CDN                  : 'https://staging-cdn.shopbanquet.com',
    StripePublishableKey : 'pk_test_1qlLoY7WhrYr8MI6c5DT9u6e',
    GoogleMapsApiKey     : 'AIzaSyBVBSWmf3dz5-WoOiwB0IzuZ9x1_UXgXkg',
    SegmentWriteKey      : 'Tc2QqemIZNnPy34DMYXbWSIrSx7s6bsX'
  },
  production: {
    ApiBaseUrl           : 'https://delectory.delectable.com/api',
    MerchantBanquetUrl   : 'https://merchants.shopbanquet.com',
    BanquetUrl           : 'https://shopbanquet.com',
    CDN                  : 'https://cdn.shopbanquet.com',
    StripePublishableKey : 'pk_live_hUa8P8XR72EnAjBMPUSh3JKt',
    GoogleMapsApiKey     : 'AIzaSyBVBSWmf3dz5-WoOiwB0IzuZ9x1_UXgXkg',
    SegmentWriteKey      : 'uderD3sMVTsDfXGIg5YLiY0LbnBYXdqv'
  },
  test: {
    ApiBaseUrl           : 'http://localhost:3000/api',
    BanquetUrl           : 'http://localhost:4000',
    CDN                  : 'http://localhost:3001',
  }
}[(typeof window !== 'undefined' ? window.ENV : (process.env.NODE_ENV || 'development'))];



// WEBPACK FOOTER //
// banquet/config/client.js